var App = App || {};

class Login {
    constructor() {
        // PROPERTIES
        this.login = document.getElementById('login')
        this.toggleButton = document.getElementById('login-toggle');

        // METHODS
        this.openMenu = () => {
            App.HamburgerNav.closeMenu();
            this.login.classList.add('login--open');
            this.toggleButton.ariaExpanded = 'true';
            this.setFocusableElements();
        }

        this.closeMenu = () => {
            this.login.classList.remove('login--open');
            this.toggleButton.ariaExpanded = 'false';
        }

        this.toggleMenu = () => {
            this.login.classList.contains('login--open') ? this.closeMenu() : this.openMenu();
        }

        this.onKeyDown = e => {
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            let isEscapePressed = e.key === 'Escape' || e.keyCode === 27;

            if (isEscapePressed) {
                this.closeMenu();
                return;
            }

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === this.focusableElements[1] && this.toggleButton.ariaExpanded === 'true') {
                    this.toggleButton.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }     
                else if (document.activeElement === this.toggleButton && this.toggleButton.ariaExpanded === 'true') {
                    this.lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }                
            } else { // if tab key is pressed
                if (document.activeElement === this.lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    this.firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
                else if (document.activeElement === this.toggleButton && this.toggleButton.ariaExpanded === 'true') { // if toggle button has focus and menu is open, send focus to first element in menu
                    this.focusableElements[1].focus(); // add focus for the first focusable element in menu
                    e.preventDefault();
                }
            }
        }

        this.setFocusableElements = () => {
            const focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';            
            this.focusableElements = [...this.login.querySelectorAll(focusable)];
            this.focusableElements.unshift(this.toggleButton)
            this.firstFocusableElement = this.focusableElements[0]; // get first element to be focused
            this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1]; // get last element to be focused
        }

        // EVENTS
        if (this.toggleButton && this.login) {
            this.toggleButton.addEventListener('click', e => {
                e.stopPropagation();
                this.toggleMenu();
            });

            this.login.addEventListener('click', e => {
                e.stopPropagation();
            });

            document.addEventListener('click', this.closeMenu);
            document.addEventListener('keydown', this.onKeyDown);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    App.Login = new Login();
});